import type { FC } from 'react';
const HomePageBlogHeader: FC = () => {
  return <div className="mb-4" data-sentry-component="HomePageBlogHeader" data-sentry-source-file="HomePageBlogHeader.tsx">
      <h5 className="mb-4 font-bold text-blueFour sm:mb-4 sm:text-center sm:text-2xl">روزنامه‌دیواری</h5>
      <div className="mb-6 text-2xl font-bold text-blueFive sm:mb-12 sm:text-center sm:text-4xl sm:leading-[55px]">
        خوندنی‌های آی‌نو از درس و مدرسه
      </div>
      <p className="text-lg leading-[35px] text-blackFive">
        هر سوالی از دنیای درس، مدرسه، انتخاب رشته، انتخاب شغل و... داری جوابش رو توی روزنامه‌دیواری آی‌نو پیدا می‌کنی.این
        روزنامه‌دیواری هر روزبا مقاله‌های آموزشی و مشاوره‌ای به روز می‌شه!{' '}
      </p>
    </div>;
};
export default HomePageBlogHeader;